module.exports = __webpack_public_path__ + "static/media/Jockey Pulley.0562b65e.jpg";